import React from 'react';

const PeriodContext = React.createContext({
  period: 'dpToday',
  // eslint-disable-next-line no-unused-vars
  setPeriod: (period) => {},
});

export default PeriodContext;
